import { endpoints, apiSettings } from '../config/api';

// Função para fazer requisição com timeout
const fetchWithTimeout = async (url, options, timeout = apiSettings.timeout) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal
    });
    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error('Timeout da requisição');
    }
    throw error;
  }
};

// Serviço para submissão de interesse empresarial
export const submitCompanyInterest = async (formData, turnstileToken) => {
  const payload = {
    companyName: formData.nomeEmpresa,
    contactName: formData.nome,
    email: formData.email,
    phoneNumber: formData.telefone,
    description: formData.mensagem,
    city: formData.cidade,
    additionalInfo: `Cargo: ${formData.cargo}, Setor: ${formData.setor || 'Não informado'}, Funcionários: ${formData.numeroFuncionarios || 'Não informado'}, Cidade: ${formData.cidade}`,
    turnstileToken: turnstileToken
  };

  return (async () => {
    const response = await fetchWithTimeout(endpoints.companyInterest, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const error = new Error('Não foi possível enviar. Tente novamente ou escreva para contato@coffeein.club.');
      error.category = 'server';
      throw error;
    }

    return response.status === 204 ? {} : await response.json();
  })();
};

// Serviço para submissão de interesse de cafeteria
export const submitCoffeeShopInterest = async (formData, turnstileToken) => {
  const payload = {
    coffeeShopName: formData.nomeCafeteria,
    contactName: formData.nome,
    email: formData.email,
    phoneNumber: formData.telefone,
    address: formData.endereco,
    city: formData.cidade,
    description: formData.mensagem,
    additionalInfo: `Tipo: ${formData.tipoEstabelecimento || 'Não informado'}`,
    turnstileToken: turnstileToken
  };

  return (async () => {
    const response = await fetchWithTimeout(endpoints.coffeeShopInterest, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const error = new Error('Não foi possível enviar. Tente novamente ou escreva para contato@coffeein.club.');
      error.category = 'server';
      throw error;
    }

    return response.status === 204 ? {} : await response.json();
  })();
};

// Função utilitária para validar dados do formulário
export const validateFormData = (formData, type) => {
  const errors = [];

  if (type === 'company') {
    if (!formData.nomeEmpresa?.trim()) errors.push('Nome da empresa é obrigatório');
    if (!formData.nome?.trim()) errors.push('Nome do contato é obrigatório');
    if (!formData.email?.trim()) errors.push('Email é obrigatório');
    if (!formData.cargo?.trim()) errors.push('Cargo é obrigatório');
  } else if (type === 'coffeeShop') {
    if (!formData.nomeCafeteria?.trim()) errors.push('Nome da cafeteria é obrigatório');
    if (!formData.nome?.trim()) errors.push('Nome do contato é obrigatório');
    if (!formData.email?.trim()) errors.push('Email é obrigatório');
    if (!formData.cidade?.trim()) errors.push('Cidade é obrigatória');
  }

  // Validação de email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (formData.email && !emailRegex.test(formData.email)) {
    errors.push('Email inválido');
  }

  return errors;
};

// Função para formatar mensagens de sucesso
export const getSuccessMessage = (type) => {
  if (type === 'company') {
    return 'Interesse empresarial registrado com sucesso! Nossa equipe comercial entrará em contato em breve.';
  } else if (type === 'coffeeShop') {
    return 'Interesse da cafeteria registrado com sucesso! Entraremos em contato em breve.';
  }
  return 'Formulário enviado com sucesso!';
};

// Função para formatar mensagens de erro
export const getErrorMessage = (error) => {
  if (error.message.includes('Timeout')) {
    return 'Tempo limite excedido. Tente novamente.';
  }
  if (error.message.includes('Failed to fetch')) {
    return 'Erro de conexão. Verifique sua internet e tente novamente.';
  }
  return error.message || 'Erro inesperado. Tente novamente.';
};
